<template>
    <div id="converters_layout">
        <div
            is="ErrorBox"
            :errors="errors"
        >
        </div>
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div v-else class="ui active centered inline large loader"></div>
    </div>
</template>

<script>
import ErrorBox from '../.components/errors.vue'
export default {
    data: function() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
        this.init();
    },
    mounted: function() {
    },
    methods: {
        init: async function() {
            var that = this;
            await new Promise(resolve => {
                that.is_initialized = false;
                resolve();
            });
            await new Promise(resolve => {
                that.$noty.information("翻譯本管理初始化完畢");
                that.is_initialized = true;
                resolve();
            });
        },
    },
    components: {
        ErrorBox,
    }
}
</script>
